// extracted by mini-css-extract-plugin
module.exports = {"buttonGroups":"button-groups_buttonGroups_2Bijb","red":"button-groups_red_1kKpj","button":"button-groups_button_2_cOI","messageCount":"button-groups_messageCount_3t1Ee"};